import styled from 'styled-components';

export const Sidebar = styled.div`
  display: flex;
  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: ${props => (props.visible ? '255px' : '0px')};
  flex-direction: column;
  flex-wrap: nowrap;

  transition: flex .3s ${props => (props.visible ? 'ease-in' : 'ease-out')};
  overflow: hidden;
  border-right: 1px solid #f4f5f6;
  border-radius: 4px;
  background-color: rgb(244, 245, 247);
  word-break: normal;
  word-wrap: break-word;
  list-style: none;
  padding: ${props => (props.visible ? ' 8px 8px 0 8px' : '0')};
`;
